import React from 'react';
import * as Sentry from '@sentry/react';
import NotFoundPage from "../routes/NotFoundPage/NotFoundPage";

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            info: null
        };
    }

    static getDerivedStateFromError(error) {
        // Aktualizuje stan, aby kolejny render pokazał UI błędu
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // Logowanie błędu do konsoli lub serwisu raportowania błędów
        this.setState({ error, info });
        console.error(error, info);
        
        // Wysyłanie błędu do Sentry
        try {
            Sentry.withScope((scope) => {
                scope.setContext('componentStack', info.componentStack);
                Sentry.captureException(error);
            });
        } catch (sentryError) {
            console.error('Failed to send error to Sentry:', sentryError);
        }
    }

    render() {
        if (this.state.hasError) {
            // Opcja 1: Renderowanie NotFoundPage
            return <NotFoundPage />;

            // Opcja 2: Renderowanie szczegółowego komunikatu (odkomentuj, jeśli wolisz)
            /*
            return (
              <Box m="md" css={{ textAlign: 'center' }}>
                <H2 mb="md">Coś poszło nie tak...</H2>
                <Box>{this.state.error && this.state.error.toString()}</Box>
                <Box>{this.state.info && this.state.info.componentStack}</Box>
                <Link onClick={() => window.location.reload()}>Odśwież</Link>
              </Box>
            );
            */
        }

        return this.props.children;
    }
}

export default ErrorBoundary;